
module.exports = require('./dist/emotion')


//////////////////
// WEBPACK FOOTER
// ../node_modules/grid-styled/emotion.js
// module id = 592
// module chunks = 0